export default __webpack_public_path__ + "static/media/plan.0cfcb1a1.png";